import React from "react";

const HeaderChatIcon = ({ className, fill = "var(--color-primary)" }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="21"
		height="20"
		viewBox="0 0 21 20"
		fill="none"
		className={className}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.3335 2.66683C4.09038 2.66683 3.85722 2.76341 3.68531 2.93532C3.51341 3.10722 3.41683 3.34038 3.41683 3.5835V16.0371L5.51865 13.9353C5.69056 13.7634 5.92371 13.6668 6.16683 13.6668H17.1668C17.4099 13.6668 17.6431 13.5703 17.815 13.3983C17.9869 13.2264 18.0835 12.9933 18.0835 12.7502V3.5835C18.0835 3.34038 17.9869 3.10722 17.815 2.93532C17.6431 2.76341 17.4099 2.66683 17.1668 2.66683H4.3335ZM2.38895 1.63895C2.90468 1.12323 3.60415 0.833496 4.3335 0.833496H17.1668C17.8962 0.833496 18.5956 1.12323 19.1114 1.63895C19.6271 2.15468 19.9168 2.85415 19.9168 3.5835V12.7502C19.9168 13.4795 19.6271 14.179 19.1114 14.6947C18.5956 15.2104 17.8962 15.5002 17.1668 15.5002H6.54653L3.14834 18.8983C2.88618 19.1605 2.4919 19.2389 2.14937 19.0971C1.80683 18.9552 1.5835 18.6209 1.5835 18.2502V3.5835C1.5835 2.85415 1.87323 2.15468 2.38895 1.63895Z"
			fill={fill}
		/>
	</svg>
);

export default HeaderChatIcon;
